import { Link } from 'react-router-dom';

const collections = [
  {
    name: 'Wind Spinners',
    image: 'https://static.readdy.ai/image/577c45d6defa6ac02f4bf39c73856fa0/c4e1916781f99e894df361317e0bc41a.jpeg',
    path: '/collections/wind-spinners',
  },
  {
    name: 'Soapstone Animals',
    image: 'https://storage.readdy-site.link/project_files/8b56c003-1675-4c77-980a-9eb59e640845/50f806fd-2a64-4d4d-a878-8705c9132839_909427_f32f0d867c8f4ecd958d771f001bbe19mv2.jpg?v=0ca15b16bde757b3cdc7f5dab56e4bfb',
    path: '/collections/soapstone-animals',
  },
  {
    name: 'Wire Wrapped Stones',
    image: 'https://storage.readdy-site.link/project_files/8b56c003-1675-4c77-980a-9eb59e640845/ea3c4dba-5c2b-43ae-9cb3-6677806a47e5_909427_ee632c35f559489caf224c5c25c5405dmv2.png?v=fef261a9a13c2d74d1ccbc191461a9c6',
    path: '/collections/wire-wrapped-stones',
  },
  {
    name: 'Accessories',
    image: 'https://static.wixstatic.com/media/34789f_298255760caa41e1a9e28be56b08e8d9~mv2.jpg',
    path: '/collections/accessories',
  },
];

export default function ShopByCollection() {
  return (
    <section className="py-16 md:py-24 bg-[#f0f4f7]">
      <div className="container-main">
        <div className="text-center mb-12 md:mb-14">
          <span className="section-subheading">Explore</span>
          <h2 className="section-heading mt-3">Shop by Collection</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {collections.map((collection) => (
            <Link
              key={collection.name}
              to={collection.path}
              className="group block"
            >
              <div className="bg-white border border-gray-100 rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300">
                <div className="relative aspect-[4/5] overflow-hidden bg-[#f8f8f8]">
                  <img
                    src={collection.image}
                    alt={collection.name}
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                </div>
                <div className="p-5 text-center">
                  <h3 className="font-serif text-lg md:text-xl text-ink mb-2 group-hover:text-[#4f528d] transition-colors">
                    {collection.name}
                  </h3>
                  <span className="text-xs font-sans text-[#4f528d] font-semibold uppercase tracking-label">
                    Shop Collection
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}